import React from 'react'
import {DashboardCard as PepsicoDashboardCard} from '@pepsico-ds/ui'
import PropTypes from 'prop-types'

/**
 * DashboardCard renders with specified properties.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.centralIcon - The central icon for the card.
 * @param {Object} props.ctaPrimary - The primary call-to-action for the card.
 * @param {string} props.title - The title of the card.
 * @param {boolean} props.isDark - Whether the card is in dark mode.
 * @returns {JSX.Element} The rendered DashboardCard component.
 */
const DashboardCard = ({centralIcon, ctaPrimary, title, isDark}) => {
  return <PepsicoDashboardCard isDark={isDark} centralIcon={centralIcon} ctaPrimary={ctaPrimary} title={title} />
}

DashboardCard.propTypes = {
  centralIcon: PropTypes.string,
  ctaPrimary: PropTypes.object,
  title: PropTypes.string,
  isDark: PropTypes.bool,
}

export default DashboardCard
